import { render, staticRenderFns } from "./ckproIndex.vue?vue&type=template&id=0df70a95&scoped=true"
import script from "./ckproIndex.vue?vue&type=script&lang=js"
export * from "./ckproIndex.vue?vue&type=script&lang=js"
import style0 from "./ckproIndex.vue?vue&type=style&index=0&id=0df70a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df70a95",
  null
  
)

export default component.exports